import { ReceiptQrCode } from '@/features/receipts/components/ReceiptQrCode';
import { votingPublicUrl } from '../utils/publicUrl';

interface VotingQrProps {
  electionId: string;
  size?: number;
  /** Show the link under the code (for admins) */
  showLink?: boolean;
}

/** QR of the public voting page. The link is fixed (it is also printed on every badge). */
export function VotingQr({ electionId, size = 280, showLink = false }: VotingQrProps) {
  const url = votingPublicUrl(electionId);
  return (
    <div className="flex flex-col items-center gap-3">
      <div className="rounded-2xl bg-white p-3 shadow">
        <ReceiptQrCode url={url} size={size} />
      </div>
      {showLink && <p className="max-w-full break-all text-center text-xs text-muted-foreground">{url}</p>}
    </div>
  );
}
